import React, { useState } from 'react';
import ItemForm from './ItemForm';
import ItemList from './ItemList';

function ShoppingList() {
  const [items, setItems] = useState([]);

  function addItemHandler(item) {
    setItems(prevItems => [...prevItems, item]);
  };

  function removeItemHandler(item) {
    setItems(prevItems => prevItems.filter(i => i !== item));
  };

  return (
    <div>
      <ItemList items={items} removeItem={removeItemHandler} />
      <ItemForm addItem={addItemHandler} />
    </div>
  );
}

export default ShoppingList;